import React from 'react';
import styled from 'styled-components';
// import {Link} from "react-router-dom";

import {CHARCOAL, WHITESMOKE, OzContainer, OzRow, OzCol, OzLogo} from "@ozwol/webui";


const Container = styled.div`
  padding: 35px 0px;
  width: 100%;
  background-color: ${CHARCOAL};
  color: ${WHITESMOKE};
  text-align: left;

  &, & * {
    box-sizing: border-box;
  }
`;



const Menu = styled.div`




`;

const Title = styled.div`
  margin-bottom: 20px;
  font-size: 15px;
  font-weight: bold;
`;
const Items = styled.div`

`;

const Item = styled.div`
  font-size: 15px;
  font-weight: bold;
  line-height: 21px;
  font-weight: bold;
  padding-bottom: 3px;

  & a{
    color: ${WHITESMOKE};
    text-decoration: none;
  }
  & a:hover{
    color: ${WHITESMOKE};
    text-decoration: underline;
  }

`;

const Details = styled.div`
  margin-top: 15px;
  font-size: 15px;
  line-height: 25px;
`;
const Foot = styled.div`
  margin-top: 70px;
  font-size: 15px;
  text-align: center;
  line-height: 25px;
`;




const Footer = ({ address = null, rights = null, title1 = "", title2 = "", title3 = "", items1 = [], items2 = [], items3 = [], logoLink = null }) => {

  return (
    <Container>
      <OzContainer>
        <OzRow>
          <OzCol widthmd="3">
            {logoLink ?
              <>
              {/*<Link to={logoLink}>
                <OzLogo variant={"inverse"} width={"150px"} />
              </Link>*/}
              </>
            :
              <OzLogo variant={"inverse"} width={"150px"} />
            }
            <Details>{
              address ?
                address
              :
                <>
                  Via A. Pacinotti 4/b<br/>
                  37135 Verona (VR)<br/>
                  Italia<br/>
                  <br/>
                  +39 045 2456369<br/>
                </>
            }</Details>
          </OzCol>
          <OzCol widthmd="3">
            <Menu>
              <Title>{title1 ? title1 : <span>&nbsp;</span>}</Title>
              <Items>
                {items1.map((item, j) =>
                  <Item key={j}>
                    {item}
                  </Item>
                )}
              </Items>
            </Menu>
          </OzCol>
          <OzCol widthmd="3">
            <Menu>
              <Title>{title2 ? title2 : <span>&nbsp;</span>}</Title>
              <Items>
                {items2.map((item, j) =>
                  <Item key={j}>
                    {item}
                  </Item>
                )}
              </Items>
            </Menu>
          </OzCol>
          <OzCol widthmd="3">
            <Menu>
              <Title>{title3 ? title3 : <span>&nbsp;</span>}</Title>
              <Items>
                {items3.map((item, j) =>
                  <Item key={j}>
                    {item}
                  </Item>
                )}
              </Items>
            </Menu>
          </OzCol>
          <OzCol widthmd="12">
            <Foot>
              <b>© {new Date().getFullYear()} Ozwol Technologies. {
                rights ?
                  rights
                :
                  "Tutti i diritti riservati."
              }</b><br/>
              Ozwol Technologies S.r.l. - Via A. Pacinotti 4/b, 37135 Verona - Italia<br/>
              C.F./P.IVA: 04590420230 - REA: VR-433276 - Camera di Commercio di Verona - CS: € 10.000 I.V. - PEC: ozwol @ pec . net<br/>
            </Foot>
          </OzCol>
        </OzRow>
      </OzContainer>
    </Container>
  )
}

export default Footer
